import React, { useCallback, useEffect, useId, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './km-detail.css';

const reading = value => value == null || String(value).trim() === '' ? null : Number(String(value).replace(',', '.'));
const fmt = value => Number(value).toLocaleString('tr-TR', { maximumFractionDigits: 1 });
const when = (date, time) => `${(date || '').split('-').reverse().join('.') || 'Tarih belirtilmemiş'}${time ? ` ${time}` : ''}`;

export default function KmDetail({ record, previous, kind = 'empty', value }) {
  const [open, setOpen] = useState(false), [pinned, setPinned] = useState(false), [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null), tooltipRef = useRef(null), closeTimer = useRef(null), id = useId();
  const empty = kind === 'empty';
  const start = reading(empty ? previous?.dokumKm : record.dolumKm), end = reading(empty ? record.dolumKm : record.dokumKm);
  const km = empty ? value : start != null && end != null ? end - start : null;
  const close = useCallback(() => { clearTimeout(closeTimer.current); setOpen(false); setPinned(false); }, []);
  const show = () => { clearTimeout(closeTimer.current); setOpen(true); };
  const hide = () => { if (!pinned) closeTimer.current = setTimeout(() => setOpen(false), 150); };
  useEffect(() => () => clearTimeout(closeTimer.current), []);
  useLayoutEffect(() => {
    if (!open) return;
    const anchor = buttonRef.current?.getBoundingClientRect(), tooltip = tooltipRef.current;
    if (!anchor || !tooltip) return;
    const width = tooltip.offsetWidth, height = tooltip.offsetHeight;
    const left = Math.max(12, Math.min(anchor.left, window.innerWidth - width - 12));
    const top = anchor.bottom + height + 20 <= window.innerHeight ? anchor.bottom + 8 : Math.max(12, anchor.top - height - 8);
    setPosition({ top, left });
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const outside = event => { if (!buttonRef.current?.contains(event.target) && !tooltipRef.current?.contains(event.target)) close(); };
    const escape = event => { if (event.key === 'Escape') close(); };
    document.addEventListener('pointerdown', outside); document.addEventListener('keydown', escape);
    window.addEventListener('resize', close); window.addEventListener('scroll', close, true);
    return () => { document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', escape); window.removeEventListener('resize', close); window.removeEventListener('scroll', close, true); };
  }, [open, close]);
  if (km == null || !Number.isFinite(km) || start == null || end == null || !Number.isFinite(start) || !Number.isFinite(end)) return null;
  return <>
    <button ref={buttonRef} type="button" className="formen-km-detail" aria-expanded={open} aria-describedby={open ? id : undefined}
      onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={() => { if (!pinned) close(); }}
      onClick={() => { setPinned(!pinned); setOpen(!pinned); }}>
      {empty ? 'Boş KM' : 'Sefer KM'}: {fmt(km)} KM
    </button>
    {open && createPortal(<div ref={tooltipRef} id={id} role="tooltip" className="formen-km-tooltip" style={position} onMouseEnter={show} onMouseLeave={hide}>
      <b>{empty ? 'Boş dönüş hesabı' : 'Sefer kilometresi hesabı'}</b>
      <span className="formen-km-tooltip-route">{(empty ? previous?.mtaAdi : record.fabrikaAdi) || 'Çıkış yeri belirtilmemiş'} → {(empty ? record.fabrikaAdi : record.mtaAdi) || 'Varış yeri belirtilmemiş'}</span>
      <dl><dt>{empty ? 'Önceki döküm' : 'Fabrika çıkışı'}</dt><dd>{empty ? when(previous?.dokumTarihi, previous?.dokumSaati) : when(record.dolumTarihi, record.dolumSaati)}</dd>
        <dt>{empty ? 'Fabrika çıkışı' : 'MTA dökümü'}</dt><dd>{empty ? when(record.dolumTarihi, record.dolumSaati) : when(record.dokumTarihi, record.dokumSaati)}</dd>
        {empty && previous?.seriNo && <><dt>Önceki döküm fişi</dt><dd>{previous.seriNo}</dd></>}
        {!empty && record.seriNo && <><dt>Döküm fişi</dt><dd>{record.seriNo}</dd></>}
      </dl>
      <span className="formen-km-tooltip-calculation">{fmt(end)} − {fmt(start)} = <b>{fmt(km)} KM</b></span>
    </div>, document.body)}
  </>;
}
